<template>
  <div>
    <el-form ref="form" :model="form" class="form_flex">
      <el-row>
        <el-col :span="8">
          <el-form-item
            label="租购意向"
            :label-width="formLabelWidth"
            prop="isSale"
          >
            <el-select
              class="search-select1"
              v-model="isSale"
              placeholder="请选择租购意向"
              @change="handleSlectIntention"
            >
              <el-option
                v-for="(item, index) in intentionList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="推荐人"
            :label-width="formLabelWidth"
            prop="userId"
          >
            <el-select
              class="select"
              v-model="form.userId"
              filterable
              remote
              placeholder="请输入推荐人"
              :remote-method="searchUser"
              @change="checkItem"
              clearable
              :loading="loading"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="推荐人电话"
            :label-width="formLabelWidth"
            prop="userMobile"
          >
            <el-input
              class="search-input"
              v-model="form.userMobile"
              placeholder="请输入推荐人电话"
              @blur="onBlur"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="客户姓名"
            prop="customerName"
          >
            <el-input
              class="search-input"
              v-model="form.customerName"
              placeholder="请输入客户姓名"
              @blur="onBlur"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="客户电话"
            prop="customerPhone"
          >
            <el-input
              class="search-input"
              v-model="form.customerPhone"
              placeholder="请输入客户电话"
              @blur="onBlur"
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- 1 这里搜索 -->
        <!-- <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="意向楼盘"
            prop="houseId"
          >
            <el-select
              class="select"
              v-model="form.houseId"
              filterable
              remote
              placeholder="请输入意向楼盘"
              :remote-method="searchHouse"
              @change="checkItem"
              clearable
              :loading="loading"
            >
              <el-option
                v-for="item in houseList"
                :key="item.value"
                :label="handleUserDecrypt(item.label)"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <!-- 1 枚举-->
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="已报备来源"
            prop="source"
          >
            <el-select
              placeholder="请选择已报备来源"
              :loading="loading"
              v-model="form.source"
            >
              <el-option
                v-for="item in sourceList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="企业名称"
            prop="companyName"
          >
            <el-input
              class="search-input"
              v-model="form.companyName"
              placeholder="请输入企业名称"
              @blur="onBlur"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label-width="formLabelWidth"
            label="提交时间"
            prop="submissionTime"
          >
            <el-date-picker
              v-model="submissionTime"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="btn">
            <el-button @click="onSearch" icon="el-icon-search" size="small"
              >查询</el-button
            >
            <el-button
              size="small"
              icon="el-icon-plus"
              @click="resetForm('form')"
              >清空</el-button
            >
            <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
              >刷新</el-button
            >
            <PermissionsBtn
              :icon="'el-icon-download'"
              :btnType="'primary'"
              :permissionName="'_Export'"
              :downloadUrl="'/userAdmin/Introduce/downLoadFailIntroduce'"
              :checkList="checkList"
              :form="exportForm"
            ></PermissionsBtn>
            <!-- <el-button
              size="small"
              type="success"
              @click="isExpend = !isExpend"
              >{{ !isExpend ? '展开' : '收起' }}</el-button
            > -->
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getUserModelApi } from '@/api/user.js';
import { getHouseByAreaApi } from '@/api/areaApi.js';
import { introduceSourcedApi } from '@/api/introduce.js';
import { decrypt, encrypt } from '@/utils/encryp';
export default {
  name: 'UserSearchBar',
  // 与 layout 组件配合使用 provide / inject组合
  inject: ['reload'], // 注入reload方法
  props: {
    checkList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      intentionList: [
        {
          label: '租赁',
          value: 0,
        },
        {
          label: '购买',
          value: 1,
        },
      ],
      // 表单内容
      form: {
        reward: '', // 推荐人
        mobile: '', // 推荐人电话
        customerName: '', // 客户名称
        customerPhone: '', // 客户电话
        lastSixId: '',
        isSale: '', // 租购意向
        require: '', // 客户意向房源
        source: '', // 已报备来源
        factSalesPersonName: '', // 销售员
        companyName: '', // 企业名称
        remark: '', // 备注
        // salesPersonName: '', // 接待销售
        // customerServiceName: '', //  客服名称
        // appointmentStartTime: '', // 报备时间
        // appointmentEndTime: '',
        // availableStartTime: '', // 看房有效期
        // availableEndTime: '',
        // updateStartTime: '', // 修改时间
        // updateEndTime: '',
        // arriveStartTime: '',
        // arriveEndTime: '',
      },
      exportForm: {},
      isSale: '',
      userName: '',
      dateTime: [],
      updateTime: [], // 修改时间
      options: [],
      updaterOptions: [],
      submissionTime: [], // 提交时间
      houseList: [], // 楼盘列表
      loading: false,
      path: '',
      appointmentTime: '',
      availableTime: '',
      arriveTime: '',
      isExpend: false,
      areaId: '',
      sourceList: [],
    };
  },
  computed: {
    ...mapGetters(['statusList', 'pickerOptions', 'roleList']),
  },
  watch: {
    // 将标准时间转换成 yyyy-mm-dd
    // dateTime: function (val) {
    //   let timeList = val.map((item) => {
    //     return this.$moment(item).format('YYYY-MM-DD HH:mm:ss');
    //   });
    //   this.form.appointmentStartTime = timeList[0];
    //   this.form.appointmentEndTime = timeList[1];
    //   return;
    // },
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
    this.areaId = localStorage.getItem('areaId')
      ? JSON.parse(localStorage.getItem('areaId')).areaId
      : '';
    this.searchSource();
  },
  methods: {
    // 租购下拉选择
    handleSlectIntention(val) {
      this.form.isSale = val > 0;
      // console.log(this.form.isSale);
      // console.log(val);
    },
    // 搜索用户
    async searchUser(val) {
      this.loading = true;
      let res = await getUserModelApi({ userName: val, areaId: this.areaId });
      this.loading = false;
      this.options = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    // 失去焦点
    onBlur() {
      let { companyName, customerName, customerPhone, userMobile } = this.form;
      this.exportForm = {
        ...this.form,
        companyName: companyName ? encrypt(companyName) : '',
        customerName: customerName ? encrypt(customerName) : '',
        customerPhone: customerPhone ? encrypt(customerPhone) : '',
        userMobile: userMobile ? encrypt(userMobile) : '',
      };
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 获取来源
    async searchSource() {
      this.loading = true;
      let res = await introduceSourcedApi({
        // areaId: this.areaId,
      });
      this.loading = false;
      // console.log('获取来源', res.data);
      this.sourceList = res.data.sources;
    },
    // 搜索修改人
    async searchUpadater(val) {
      this.loading = true;
      let res = await getUserModelApi({ userName: val, areaId: this.areaId });
      this.loading = false;
      this.updaterOptions = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    // 搜索楼盘
    async searchHouse(val) {
      this.loading = true;
      try {
        let res = await getHouseByAreaApi({
          userName: val,
          areaId: '',
        });
        this.loading = false;
        this.houseList = JSON.parse(
          JSON.stringify(res.data.dataList)
            .replace(/houseName/g, 'label')
            .replace(/houseId/g, 'value')
        );
      } catch (error) {
        console.log(error);
      }
    },

    // 选择下拉选项
    checkItem(val) {
      this.form.userId = val;
    },

    // 修改人下拉选项
    checkUpdaterItem(val) {
      this.form.updateUserId = val;
    },

    // 搜索，触发父组件请求数据的方法
    onSearch() {
      // 0 = 全部， 没有0这个状态，重置为0
      // if (this.form.status === 0) {
      //   this.form.status = '';
      // }
      // 报备时间
      // this.form['appointmentStartTime'] = this.appointmentTime
      //   ? this.appointmentTime[0]
      //   : '';
      // this.form['appointmentEndTime'] = this.appointmentTime
      //   ? this.appointmentTime[1]
      //   : '';
      // 修改时间
      // this.form['updateStartTime'] = this.updateTime ? this.updateTime[0] : '';
      // this.form['updateEndTime'] = this.updateTime ? this.updateTime[1] : '';
      // 看房有效期
      // this.form['availableStartTime'] = this.availableTime
      //   ? this.availableTime[0]
      //   : '';
      // this.form['availableEndTime'] = this.availableTime
      //   ? this.availableTime[1]
      //   : '';
      // 到访时间
      // this.form['arriveStartTime'] = this.arriveTime ? this.arriveTime[0] : '';
      // this.form['arriveEndTime'] = this.arriveTime ? this.arriveTime[1] : '';

      // 提交时间
      this.form['createStartTime'] = this.submissionTime
        ? this.submissionTime[0]
        : '';
      this.form['createEndTime'] = this.submissionTime
        ? this.submissionTime[1]
        : '';
      let { customerName, customerPhone, userMobile } = this.form;
      this.$emit('search', {
        ...this.form,
        ...{
          customerName: customerName ? encrypt(customerName) : '',
          customerPhone: customerPhone ? encrypt(customerPhone) : '',
          // companyName: companyName ? encrypt(companyName) : '',
          userMobile: userMobile ? encrypt(userMobile) : '',
        },
      });
    },

    // 刷新当前页面
    onRefresh() {
      // this.reload();
      this.$emit('reload');
      this.$router.push({
        path: '/home/user/visit',
        query: {
          channel: 'failure',
        },
      });
    },

    // 清空表单
    resetForm(formName) {
      this.form.isSale = '';
      this.isSale = '';
      this.submissionTime = [];
      // this.appointmentTime = [];
      // this.availableTime = [];
      // this.dateTime = [];
      // this.userName = '';
      // this.updateTime = [];
      // this.availableTime = [];
      // this.arriveTime = [];
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-input {
  margin: 0 10px;
  width: 260px;
}

.search-select1 {
  // width: 120px;
}

.select {
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
